<template>
  <div class="invoice-issue">
    <fixed-header title="开具发票"></fixed-header>
    <div class="invoice-issue__main scroll-touch">
      <div class="invoice-issue__main__wrap ">
        <div class="invoice-issue__main__wrap-line">
          <span>发票详情</span>
        </div>
        <div class="invoice-issue__main__wrap-info">
          <div class="invoice-issue__main__wrap-info-detail">
            <InvoiceTitleDetail :from="currentFrom" :invoice-info="invoiceTitleInfo"
                                :is-show="true"></InvoiceTitleDetail>
          </div>
        </div>
        <div class="invoice-issue__main__wrap-amount invoice-issue__main__wrap-item" @click="gotoInvoiceInfo">
          <span class="invoice-issue__main__wrap-amount-desc">总金额</span>
          <p><span>{{ invoiceOrderCheckInfo.invoiceMoney }}</span>元</p>
          <span class="invoice-issue__main__wrap-amount-num">共1张</span>
          <i :class="['icon', 'invoice_arrow_trans']"></i>
        </div>
        <div class="invoice-issue__main__wrap-line">
          <span>接收方式</span>
        </div>
        <div class="invoice-issue__main__wrap-email invoice-issue__main__wrap-item">
          <p>电子邮箱<span>*</span></p>
          <input-item v-model="invoiceOrderCheckInfo.noticeEmail" class="invoice-issue__main__wrap-email-input"
                      placeholder="用于向您发送电子发票"
                      type="text"></input-item>
        </div>
      </div>
      <div class="invoice-issue__main__bottom" @click="invoiceOrderCheckInfo.noticeEmail ? submitIssue() : ''">
        <span :class="invoiceOrderCheckInfo.noticeEmail ? 'invoice-issue__main__bottom-active' : ''">提交申请</span>
      </div>

    </div>
  </div>
</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
import InvoiceTitleDetail from 'components/invoice/title/detail';
import InputItem from 'components/common/InputItem';
import * as invoiceApis from 'apis/invoice';

export default {
  name: 'index',
  components: {
    FixedHeader, InvoiceTitleDetail, InputItem,
  },
  data() {
    return {
      currentFrom: 'issue',
      invoiceOrderCheckInfo: {
        invoiceMoney: 0,
        orderSns: '',
        noticeEmail: '',
      },
      invoiceTitleInfo: {},
    };
  },
  mounted() {
    this.getUserChooseIssueInfo();
  },
  methods: {
    gotoInvoiceInfo() {
      MgStat.send('click', {}, {
        mod: 'invoice_info',
        cont: '点击发票详情',
        direct: 'cntp',
        label: 'btn',
        cntp: 'haowu_invoiceIssue',
      });
      this.$router.push({ path: '/invoice/info' });
    },
    async getUserChooseIssueInfo() {
      this.invoiceTitleInfo = JSON.parse(sessionStorage.getItem('invoiceUserDefaultTitle'));
      this.invoiceOrderCheckInfo = JSON.parse(sessionStorage.getItem('invoiceOrderCheckInfo'));
    },
    async submitIssue() {
      const submitFrom = {};
      if (this.invoiceTitleInfo.titleType === 0) {
        Object.assign(submitFrom, this.invoiceTitleInfo);
      } else {
        submitFrom.invoiceTitle = this.invoiceTitleInfo.invoiceTitle;
        submitFrom.titleType = this.invoiceTitleInfo.titleType;
      }
      Object.assign(submitFrom, this.invoiceOrderCheckInfo);
      if (!submitFrom.invoiceTitle) {
        this.$toast({ message: '请填写抬头名称', duration: 1000 });
        return;
      }
      if (submitFrom.titleType === 0 && !submitFrom.taxpayer) {
        this.$toast({ message: '请填写公司税号', duration: 1000 });
        return;
      }
      const reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (!submitFrom.noticeEmail) {
        this.$toast({ message: '请填写邮箱', duration: 1000 });
        return;
      } else if (!reg.test(submitFrom.noticeEmail)) {
        this.$toast({ message: '邮箱格式错误', duration: 1000 });
        return;
      }
      MgStat.send('click', {}, {
        mod: 'submit',
        cont: '提交申请',
        direct: 'cntp',
        label: 'btn',
        cntp: 'haowu_invoiceIssue',
      });
      try {
        await invoiceApis.applyInvoiceIssue(submitFrom);
        this.$router.push({ path: '/invoice/result' });
      } catch (error) {
        this.$message(`${error.message}`);
      }
    },
  },
};
</script>

<style lang="scss">

.invoice-issue {
  height: 100%;
  background: rgba(246, 246, 246, 1);

  &__main {
    height: 100%;

    &__wrap {
      height: 100%;
      padding-bottom: 222px;

      &-line {
        height: 77px;
        display: flex;
        align-items: center;

        span {
          color: #9E9E9E;
          font-size: 26px;
          margin-left: 24px;
        }
      }

      &-info {
        background: rgba(255, 255, 255, 1);

        &-detail {
          margin-left: 24px;
          margin-right: 24px;
        }
      }

      &-item {
        height: 90px;
        background: rgba(255, 255, 255, 1);
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #323232;
        font-size: 28px;
      }

      &-amount {
        margin-top: 20px;

        &-desc {
          margin-left: 24px;
        }

        p {
          margin-left: 68px;
          width: 250px;

          span {
            color: #FF5F00 !important;
            margin: 0 10px;
          }
        }

        &-num {
          margin-left: 115px;
          margin-right: 22px;
          width: 135px;
          color: #BABABA !important;
          text-align: right;
        }
      }

      &-email {
        p {
          margin-left: 24px;

          span {
            color: #FF5F00 !important;
            font-size: 28px !important;
          }
        }

        &-input {
          flex: 1;
          margin-left: 40px;
          margin-right: 24px;
        }
      }

    }

    &__bottom {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 20px 24px 50px 24px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        text-align: center;
        padding: 20px 24px;
        width: 100%;
        font-size: 28px;
        color: #ffffff;
        background: #D1D1D1;
        border-radius: 40px;
      }

      &-active {
        background-image: linear-gradient(90deg, #fa841b 17%, #ff6002 85%) !important;
      }

    }

  }

}


</style>
